import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import ui from './ui'
import auth from './auth'

export default createStore({
    strict: process.env.NODE_ENV !== 'production',
    state: {
        version: '1.0.0',
    },
    mutations: {},
    actions: {},
    modules: {
        ui,
        auth,
    },
    plugins: [createPersistedState()],
})
